import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["label"]
const _hoisted_3 = ["value"]

import { computed, WritableComputedRef } from "vue";
import TandemInputWrapper from "@/components/TandemInputWrapper.vue";
import type { Props as WrapperProps } from "@/components/TandemInputWrapper.vue";

interface OptionGroup {
  label: string;
  options: T[];
}

interface Props extends WrapperProps {
  modelValue?: T;
  options?: T[];
  groups?: OptionGroup[];
  getKey: (input: T) => string | number | symbol;
  getLabel: (input: T) => unknown;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TandemSelect',
  props: {
    modelValue: {},
    options: {},
    groups: {},
    getKey: { type: Function },
    getLabel: { type: Function },
    errors: {},
    name: {},
    label: {},
    helpText: {},
    labelExtraClasses: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

/* eslint-disable no-undef, no-unused-vars */




const value: WritableComputedRef<T | undefined> = computed({
  get(): T | undefined {
    return props.modelValue;
  },
  set(value: T | undefined) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemInputWrapper, {
    label: _ctx.label,
    name: _ctx.name,
    "help-text": _ctx.helpText,
    required: _ctx.required,
    errors: _ctx.errors
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("select", {
        name: "content",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props?.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: _ctx.getKey(option),
            value: option
          }, _toDisplayString(_ctx.getLabel(option)), 9, _hoisted_1))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props?.groups, (group) => {
          return (_openBlock(), _createElementBlock("optgroup", {
            key: group.label,
            label: group.label
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: _ctx.getKey(option),
                value: option
              }, _toDisplayString(_ctx.getLabel(option)), 9, _hoisted_3))
            }), 128))
          ], 8, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, value.value]
      ])
    ]),
    _: 1
  }, 8, ["label", "name", "help-text", "required", "errors"]))
}
}

})